module.exports = __webpack_public_path__ + "static/media/massage-image.99571280.svg";